import {UxOption} from "@trumpf/ux.ui/dist/types/components/select/option";
import {BusinessUnitsEnum} from "../enums";
import {LockStatusFilterEnum} from "../enums/filters/lock-status-filter.enum";
import {CrudRightsEnum} from "../enums/user/crud-rights.enum";

export const getLockStatusFilterOptions = () => {
  const result: Array<UxOption> = [];
  for (const [key, value] of Object.entries(LockStatusFilterEnum)) {
    result.push({name: key, value: value, selected: false});
  }
  return result;
};

export const getBusinessUnitsValues = () => {
  const result: Array<UxOption> = [];
  for (const [key, value] of Object.entries(BusinessUnitsEnum)) {
    result.push({name: key, value: value, selected: false});
  }
  return result;
};

export const getAccessTypeOptions = () => {
  const result: Array<UxOption> = [];
  for (const [key, value] of Object.entries(CrudRightsEnum)) {
    result.push({name: key, value: value, selected: false});
  }
  return result;
};
